import React from 'react';

import type {Specie} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {specieDescription} from './specie-seo-text';

/** /specie/:id/about показывает ту же карточку, поэтому каноничный адрес всегда /specie/:id */
export const SpecieSeo: React.FC<{specie: Specie}> = ({specie}) => (
	<EntitySeo
		entity={specie}
		section="species"
		kind="вид"
		description={specieDescription(specie)}
		path={buildUrl('specie', {id: specie.id})}
		og={{kind: 'specie'}}
	/>
);
